import React from 'react'
import checkModule from './checkModule'
import StorefrontFooter from './storefront-footer.component'
import Footer from './footer.component'

function FooterWrapper() {
  return (
    <>
      {checkModule.isFooterKw ? <StorefrontFooter /> : null}
      {checkModule.isFooterKsa ? <Footer /> : null}
    </>
  )
}

export default FooterWrapper